module.exports = __webpack_public_path__ + "static/media/lunbo7.f9b80b6e.png";